import { useState } from "react";
import AppShell from "@/components/AppShell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar as CalendarUI } from "@/components/ui/calendar";

export default function CalendarPage() {
  const [month, setMonth] = useState(new Date());

  return (
    <AppShell>
      <div data-testid="calendar-page" className="space-y-6">
        <div>
          <h2
            className="text-2xl md:text-3xl font-bold"
            style={{ color: "#0b1f7a" }}
          >
            Calendar
          </h2>
          <p className="text-slate-500 mt-1 text-sm">
            Weekends (Saturday & Sunday) are highlighted in red.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle style={{ color: "#0b1f7a" }}>Monthly View</CardTitle>
          </CardHeader>
          <CardContent className="flex justify-center">
            <CalendarUI
              data-testid="school-calendar"
              month={month}
              onMonthChange={setMonth}
              modifiers={{
                weekend: (date) => date.getDay() === 0 || date.getDay() === 6,
              }}
              modifiersClassNames={{
                weekend:
                  "bg-red-500 text-white hover:bg-red-500 hover:text-white focus:bg-red-600 rounded-full",
              }}
              className="rounded-md border w-full max-w-md"
              classNames={{
                day: "h-10 w-10 p-0 font-medium hover:bg-slate-100 rounded-full",
                head_cell:
                  "text-slate-500 rounded-md w-10 font-semibold text-xs uppercase",
                cell: "relative p-0 text-center text-sm w-10 h-10",
                caption_label: "text-base font-semibold",
                nav_button: "h-8 w-8 bg-transparent p-0 hover:opacity-100",
              }}
            />
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
